import {
  ChevronLeft,
  ChevronRight,
  Menu as MenuIcon,
} from '@mui/icons-material';
import {
  AppBar,
  Box,
  CardMedia,
  Drawer,
  IconButton,
  Paper,
  Toolbar,
} from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Sidebar } from '~/components/Sidebar';
import { useAppearance } from '~/data/appearance';
import { useCompanyData } from '~/data/company/useCompanyData';
import {
  coreDataDispatchReduxFetches,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData';
import { useMenuButton } from '~/hooks/useMenu';
import { CompanyLogo } from '~/legacy-components/Topbar/components/CompanyLogo';
import { legacyColors } from '~/legacyTheme';
import { MobileMainMenuContent } from '~/scenes/MobileViews/components/MobileMainMenuContent';
import { MobileViewRouter } from '~/scenes/MobileViews/router';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { theme } from '~/theme';

import { useSxStyles } from './useStyles';

export const MobileViews = () => {
  const { t } = useTranslation();
  const {
    requiredStatus: { isInitializing, percentage },
  } = useInitializeCommonReduxData({ required: coreDataDispatchReduxFetches });

  const appearance = useAppearance();
  const sxStyles = useSxStyles(appearance.customAppearance);

  const {
    companyData,
    isLoading: isLoadingCompanyData,
    hasData: hasCompanyData,
  } = useCompanyData();

  const mainMenuState = useMenuButton();

  if (isInitializing) {
    return (
      <LoadingView>
        {t('loadingMobileView')} - {percentage}
      </LoadingView>
    );
  }

  if (
    (isLoadingCompanyData && !hasCompanyData) ||
    (appearance.isEnabled && appearance.isLoading)
  ) {
    return <LoadingView>{t('loading')}</LoadingView>;
  }

  return (
    <Box sx={sxStyles.root}>
      <AppBar>
        <Toolbar sx={sxStyles.toolbar}>
          <CompanyLogo
            companyLogoData={companyData?.logo}
            sx={{ color: legacyColors.white }}
          />

          <Box sx={sxStyles.actions}>
            <IconButton onClick={mainMenuState.open} sx={sxStyles.menuButton}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar sx={sxStyles.toolbar} />
      <Drawer
        open={mainMenuState.isOpen}
        onClose={mainMenuState.close}
        anchor={'right'}
      >
        <Sidebar sx={sxStyles.mainMenu}>
          <Box sx={sxStyles.mainMenuToggle}>
            <IconButton onClick={mainMenuState.close}>
              {theme.direction === 'rtl' ? <ChevronLeft /> : <ChevronRight />}
            </IconButton>
          </Box>
          <Box sx={sxStyles.mainMenuContent}>
            <MobileMainMenuContent />
          </Box>
          <Paper square={true} sx={sxStyles.pageFooter}>
            <CardMedia
              component="img"
              sx={sxStyles.pageFooterLogo}
              src="/img/logoBlue.png"
              alt="Solaforce"
            />
          </Paper>
        </Sidebar>
      </Drawer>
      <Box sx={sxStyles.contentContainer}>
        <MobileViewRouter />
      </Box>
    </Box>
  );
};
